<template>
  <v-container v-if="value" style="border: solid red 1px; border-radius: 25px;">
    <template>
      <div class="text-xs-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn outline color="primary" dark v-on="on" v-if="value.color">
              <span class="foo" :style="`background: ${value.color[0]}`"></span>
              <span class="foo" :style="`background: ${value.color[1]}`"></span>
              <span class="foo" :style="`background: ${value.color[2]}`"></span>
              <span class="foo" :style="`background: ${value.color[3]}`"></span>
              <span class="foo" :style="`background: ${value.color[4]}`"></span>
              <span class="foo" :style="`background: ${value.color[5]}`"></span>
            </v-btn>
            <v-btn v-else outline color="primary" dark v-on="on">
              Custom color theme
            </v-btn>
          </template>
          <v-list style="height: 300px; overflow: auto;">
            <v-list-tile v-for="(item, index) in colors" :key="index" @click="setColor(item)">
              <v-list-tile-title>
                <span class="foo" :style="`background: ${item[0]}`"></span>
                <span class="foo" :style="`background: ${item[1]}`"></span>
                <span class="foo" :style="`background: ${item[2]}`"></span>
                <span class="foo" :style="`background: ${item[3]}`"></span>
                <span class="foo" :style="`background: ${item[4]}`"></span>
                <span class="foo" :style="`background: ${item[5]}`"></span>
              </v-list-tile-title>
            </v-list-tile>
            <!-- <v-list-tile @click="themeColorSet = null">
              <v-list-tile-title>
                <span>Custom</span>
              </v-list-tile-title>
            </v-list-tile> -->
          </v-list>
        </v-menu>
      </div>
    </template>

    <template v-for="(item, i) in value.template">
      <move-vertical
        class="pt-3"
        :key="'template_' + i"
        :index="i"
        :max="value.template.length"
        @onMove="onMove(i, $event)"
        style="
                width: 20px;
                min-width: 20px;
                display: inline-block;
                float: left;
                margin-right: 10px;
              "
      >
        <a
          href="javascript:void(0);"
          v-if="value.template && value.template.length > 0"
          @click="onDelete(item)"
          style="float: left; margin-left: 3px;"
        >
          <i class="fas fa-trash"></i> </a
        >&nbsp;
      </move-vertical>
      <div
        class="pb-3"
        :key="`message_${i}`"
        v-if="item.type === 'message'"
        style="border-bottom: 1px solid;"
      >
        <h6 class="mt-4" style="float: left; font-size: 16px;">{{ $t('Add text') }}</h6>
        <template>
          <div class="text-xs-right">
            <v-menu top :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outline v-bind="attrs" v-on="on">
                  <span class="foo" :style="`background: ${item.color.hex}`"></span>
                  {{ item.color.hex }}
                </v-btn>
              </template>

              <sketch-picker v-model="item.color" />
            </v-menu>
          </div>
        </template>
        <message
          v-model="item.value"
          :index="i"
          @resetShowPreview="$emit('resetShowPreview')"
          :readonly="false"
        ></message>
      </div>
      <div
        class="pb-3"
        :key="`slideshow_${i}`"
        v-if="item.type === 'slideshow'"
        style="border-bottom: 1px solid;"
      >
        <h6 class="mt-4" style="float: left; font-size: 16px;">{{ $t('Slide show') }}</h6>
        <template>
          <div class="text-xs-right">
            <v-menu top :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outline v-bind="attrs" v-on="on">
                  <span class="foo" :style="`background: ${item.color.hex}`"></span>
                  {{ item.color.hex }}
                </v-btn>
              </template>

              <sketch-picker v-model="item.color" />
            </v-menu>
          </div>
        </template>
        <slide-show v-model="item.images"></slide-show>
      </div>
      <div
        class="pb-3"
        :key="`productlist_${i}`"
        v-if="item.type === 'productlist'"
        style="border-bottom: 1px solid; min-height: 120px;"
      >
        <h6 style="float: left; font-size: 16px;" class="mt-4">{{ $t('Show all products') }}</h6>
        <template>
          <div class="text-xs-right">
            <v-menu top :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outline v-bind="attrs" v-on="on">
                  <span class="foo" :style="`background: ${item.color.hex}`"></span>
                  {{ item.color.hex }}
                </v-btn>
              </template>

              <sketch-picker v-model="item.color" />
            </v-menu>
          </div>
        </template>
        <v-radio-group color="primary" v-model="item.option" col class="text-xs-center">
          <v-radio color="primary" :value="'tab'">
            <template slot="label">
              <span> {{ $t('Slide Grouping') }}</span>
            </template>
          </v-radio>
          <v-radio color="primary" :value="'btn'">
            <template slot="label">
              <span> {{ $t('Vertical Grouping') }}</span>
            </template>
          </v-radio>
          <v-radio color="primary" :value="'image'">
            <template slot="label">
              <span> {{ $t('Picture Grouping') }}</span>
            </template>
          </v-radio>
        </v-radio-group>
        <template v-if="item.option === 'btn'">
          {{ $t('Frame and font color') }}
          <sketch-picker v-model="item.borderColor" />
        </template>
        <template v-if="item.option === 'image'">
          {{ $t('Image aspect ratio') }}
          <image-categories v-model="item.images" :categories="categories"></image-categories
        ></template>
        <!-- <product-list></product-list> -->
      </div>
      <div
        class="pb-3"
        :key="`productslect_${i}`"
        v-if="item.type === 'productslect'"
        style="border-bottom: 1px solid;"
      >
        <h6 style="float: left; font-size: 16px;" class="mt-4">{{ $t('Select Topic') }}</h6>
        <template>
          <div class="text-xs-right">
            <v-menu top :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outline v-bind="attrs" v-on="on">
                  <span class="foo" :style="`background: ${item.color.hex}`"></span>
                  {{ item.color.hex }}
                </v-btn>
              </template>

              <sketch-picker v-model="item.color" />
            </v-menu>
          </div>
        </template>
        <product-select v-model="value.template[i]"> </product-select>
      </div>
      <div
        class="pb-3"
        :key="`photo_${i}`"
        v-if="item.type === 'photo'"
        style="border-bottom: 1px solid;"
      >
        <h6 style="float: left; font-size: 16px;" class="mt-4">{{ $t('photo') }}</h6>
        <template>
          <div class="text-xs-right">
            <v-menu top :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outline v-bind="attrs" v-on="on">
                  <span class="foo" :style="`background: ${item.color.hex}`"></span>
                  {{ item.color.hex }}
                </v-btn>
              </template>

              <sketch-picker v-model="item.color" />
            </v-menu>
          </div>
        </template>
        <photo v-model="value.template[i]"> </photo>
      </div>
      <div
        class="pb-3"
        :key="`youtube_${i}`"
        v-if="item.type === 'youtube'"
        style="border-bottom: 1px solid;"
      >
        <h6 style="float: left; font-size: 16px;" class="mt-4">{{ $t('YOUTUBE') }}</h6>
        <template>
          <div class="text-xs-right">
            <v-menu top :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outline v-bind="attrs" v-on="on">
                  <span class="foo" :style="`background: ${item.color.hex}`"></span>
                  {{ item.color.hex }}
                </v-btn>
              </template>

              <sketch-picker v-model="item.color" />
            </v-menu>
          </div>
        </template>
        <youtube v-model="value.template[i]"> </youtube>
      </div>
      <div
        class="pb-3"
        :key="`socialLink_${i}`"
        v-if="item.type === 'socialLink'"
        style="border-bottom: 1px solid;"
      >
        <h6 style="float: left; font-size: 16px;" class="mt-4">{{ $t('social_link') }}</h6>
        <template>
          <div class="text-xs-right">
            <v-menu top :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outline v-bind="attrs" v-on="on">
                  <span class="foo" :style="`background: ${item.color.hex}`"></span>
                  {{ item.color.hex }}
                </v-btn>
              </template>

              <sketch-picker v-model="item.color" />
            </v-menu>
          </div>
        </template>
        <socialLink v-model="value.template[i]"> </socialLink>
      </div>
    </template>

    <ul class="customize-message-tool pt-3" style="overflow: auto; padding-bottom: 10px;">
      <li v-ripple @click="addTemplateItem('message')">
        <vue-simple-svg
          :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
          width="40px"
          height="40px"
          class="img"
        />
        {{ $t('Message') }}
      </li>
      <li v-ripple @click="addTemplateItem('slideshow')">
        <vue-simple-svg
          :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
          width="40px"
          height="40px"
          class="img"
        />
        {{ $t('Slide show') }}
      </li>
      <li v-ripple @click="addTemplateItem('socialLink')">
        <vue-simple-svg
          :filepath="'/static/img/assets/get_started/add-image.svg'"
          width="40px"
          height="40px"
          class="img"
        />
        {{ $t('connect_platform') }}
      </li>
      <li v-ripple @click="addTemplateItem('photo')">
        <vue-simple-svg
          :filepath="'/static/img/assets/get_started/add-image.svg'"
          width="40px"
          height="40px"
          class="img"
        />
        {{ $t('photo') }}
      </li>
      <li v-ripple @click="addTemplateItem('youtube')">
        <vue-simple-svg
          :filepath="'/static/img/assets/get_started/youtube.svg'"
          width="40px"
          height="40px"
          class="img"
        />
        {{ $t('Youtube') }}
      </li>
      <li v-ripple @click="addTemplateItem('productlist')">
        <vue-simple-svg
          :filepath="'/static/img/assets/get_started/add-cart.svg'"
          width="40px"
          height="40px"
          class="img"
        />
        {{ $t('Show all products') }}
      </li>
      <li v-ripple @click="addTemplateItem('productslect')">
        <vue-simple-svg
          :filepath="'/static/img/assets/get_started/add-cart.svg'"
          width="40px"
          height="40px"
          class="img"
        />
        {{ $t('Custom item topic') }}
      </li>
    </ul>
    <template>
      <h6 class="mt-4" style="font-size: 16px;">{{ $t('Set up Checkout button') }}</h6>
      <v-radio-group color="primary" v-model="value.checkoutBtn" col>
        <v-radio color="primary" :value="'fixed'">
          <template slot="label">
            <span> {{ $t('Keep at the bottom') }} </span>
          </template>
        </v-radio>
        <v-radio color="primary" :value="'inherit'">
          <template slot="label">
            <span> {{ $t('Show when scrolling to the bottom') }}</span>
          </template>
        </v-radio>
      </v-radio-group>
    </template>
    <div class="text-xs-right">{{ this.value.template.length }} / 20</div>
  </v-container>
</template>

<script>
import SlideShow from './templateType/SlideShow'
import ImageCategories from './templateType/ImageCategories'
import Message from './templateType/Message'
import MoveVertical from '@/components/elements/MoveVertical'
import ProductList from './templateType/ProductList'
import ProductSelect from './templateType/ProductSelect'
import Photo from './templateType/Photo'
import Youtube from './templateType/Youtube'
import SocialLink from './templateType/SocialLink'
import { Sketch } from 'vue-color'
export default {
  components: {
    'sketch-picker': Sketch,
    ImageCategories,
    Message,
    SlideShow,
    MoveVertical,
    ProductList,
    ProductSelect,
    Photo,
    Youtube,
    SocialLink
  },
  props: ['value', 'categories'],
  data() {
    return {
      colors: [
        ['#FFC0CB', '#FFB6C1', '#FF69B4', '#FF1493', '#C71585', '#DB7093'],
        ['#FFA07A', '#FF7F50', '#FF6347', '#FF4500', '#FF8C00', '#FFA500'],
        ['#E6E6FA', '#D8BFD8', '#DDA0DD', '#EE82EE', '#DA70D6', '#FF00FF'],
        ['#66CDAA', '#8FBC8B', '#20B2AA', '#008B8B', '#008080', '#008000'],
        ['#B0E0E6', '#ADD8E6', '#87CEEB', '#87CEFA', '#00BFFF', '#1E90FF'],
        ['#FFEBCD', '#FFE4C4', '#FFDEAD', '#F5DEB3', '#DEB887', '#D2B48C'],
        ['#13293d', '#006494', '#247ba0', '#1b98e0', '#e8f1f2', '#ffffff'],
        ['#114b5f', '#1a936f', '#88d498', '#c6dabf', '#f3e9d2', '#ffffff'],
        ['#d8e2dc', '#ffe5d9', '#ffcad4', '#f4acb7', '#9d8189', '#ffffff'],
        ['#2b2d42', '#8d99ae', '#edf2f4', '#ef233c', '#d90429', '#ffffff'],
        ['#003049', '#d62828', '#f77f00', '#fcbf49', '#eae2b7', '#ffffff'],
        ['#f9dbbd', '#ffa5ab', '#da627d', '#a53860', '#450920', '#ffffff']
      ]
      // themeColorSet: null
    }
  },
  methods: {
    setColor(color) {
      // this.themeColorSet = color
      this.value.color = color
      this.value.template.map(item => {
        if (item.type === 'slideshow') {
          item.color = {
            hex: color[0]
          }
        } else if (item.type === 'message') {
          item.color = {
            hex: color[1]
          }
        } else if (item.type === 'productlist') {
          item.color = {
            hex: color[2]
          }
        } else if (item.type === 'productslect') {
          item.color = {
            hex: color[3]
          }
        } else if (item.type === 'photo') {
          item.color = {
            hex: color[4]
          }
        } else if (item.type === 'youtube') {
          item.color = {
            hex: color[5]
          }
        } else {
          item.color = {
            hex: '#FFFFFF'
          }
        }
      })
    },

    onDelete(itemDelete) {
      if (this.value) {
        this.value.template = this.value.template.filter(function(item) {
          return item !== itemDelete
        })
      }
    },
    addTemplateItem(type) {
      if (this.value.template.length < 20) {
        if (type === 'slideshow') {
          this.value.template.push({
            type: 'slideshow',
            images: [null],
            color: {
              hex: this.value.color !== null ? this.value.color[0] : '#FFFFFF'
            }
          })
        } else if (type === 'message') {
          this.value.template.push({
            type: 'message',
            value: null,
            color: {
              hex: this.value.color !== null ? this.value.color[1] : '#FFFFFF'
            }
          })
        } else if (type === 'productlist') {
          this.value.template.push({
            type: 'productlist',
            option: 'tab',
            borderColor: {
              hex: '#000000'
            },
            images: this.setObjectCategories(this.categories),
            color: {
              hex: this.value.color !== null ? this.value.color[2] : '#FFFFFF'
            }
          })
        } else if (type === 'productslect') {
          this.value.template.push({
            type: 'productslect',
            option: 'custom',
            productSelect: [],
            titleName: '',
            color: {
              hex: this.value.color !== null ? this.value.color[3] : '#FFFFFF'
            }
          })
        } else if (type === 'photo') {
          this.value.template.push({
            type: 'photo',
            image: [null],
            option: '2to1',
            url: null,
            padding: true,
            color: {
              hex: this.value.color !== null ? this.value.color[4] : '#FFFFFF'
            }
          })
        } else if (type === 'youtube') {
          this.value.template.push({
            type: 'youtube',
            autoplay: false,
            loop: false,
            url: null,
            color: {
              hex: this.value.color !== null ? this.value.color[5] : '#FFFFFF'
            }
          })
        } else if (type === 'socialLink') {
          this.value.template.push({
            type: 'socialLink',
            titleName: 'ช่องทางการติดต่อ',
            list: [
              {
                image: 'https://zwizai.s3.amazonaws.com/ecommerce/1654757918587Untitled-1-05.png',
                title: 'FACEBOOK',
                url: null,
                toggle: false,
                status: true,
                borderColor: { hex: '#000000' },
                fontSize: 16,
                fontColor: { hex: '#000000' }
              },
              {
                image: 'https://zwizai.s3.amazonaws.com/ecommerce/1654758048259facebook-messenger.png',
                title: 'FACEBOOK MESSENGER',
                url: null,
                toggle: false,
                status: true,
                borderColor: { hex: '#000000' },
                fontSize: 16,
                fontColor: { hex: '#000000' }
              },
              {
                image: 'https://zwizai.s3.amazonaws.com/ecommerce/1654757847098ig-logo.png',
                title: 'INSTAGRAM',
                url: null,
                toggle: false,
                status: true,
                borderColor: { hex: '#000000' },
                fontSize: 16,
                fontColor: { hex: '#000000' }
              },
              {
                image: 'https://zwizai.s3.amazonaws.com/ecommerce/1654757912943Untitled-1-03.png',
                title: 'LINE OA',
                url: null,
                toggle: false,
                status: true,
                borderColor: { hex: '#000000' },
                fontSize: 16,
                fontColor: { hex: '#000000' }
              },
              {
                image: 'https://zwizai.s3.amazonaws.com/ecommerce/1654686265712AddImage.png',
                title: 'link1',
                url: null,
                toggle: false,
                status: false,
                borderColor: { hex: '#000000' },
                fontSize: 16,
                fontColor: { hex: '#000000' }
              }
            ],
            color: {
              hex: '#FFFFFF'
            }
          })
        }
      }
    },

    setObjectCategories(categories) {
      var object = [{ '0': null }, { '1': null }]
      categories.map(item => {
        object.push({ [item.id]: null })
      })
      return object
    },
    onMove: function(index, direction) {
      if (direction == 'up') {
        this.value.template.splice(index, 0, this.value.template.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        this.value.template.splice(index, 0, this.value.template.splice(index + 1, 1)[0])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.foo {
  float: left;
  width: 20px;
  height: 20px;
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/salePage/FormSalePage.vue